export function toggleClass (element, className) {
  if (!element || !className) {
    return
  }
  element.className = className
}



// WEBPACK FOOTER //
// ./src/store/index.js